import React, { Component } from 'react';

class FlashMessage extends Component {
  constructor(props) {
    super(props);
    this.setTimeout = null;
    this.element = null;
  }

  componentDidMount() {
    //
    this.element = document.querySelector('.flash-message');
    if (this.props.flashmessage.isShowing) {
      this.setTimeout = setTimeout(() => this.props.hideMessage(), 2000);
    }
  }

  componentDidUpdate() {
    //
    this.element.classList.remove('notification-positive');
    this.element.classList.remove('notification-negative');
    if (this.props.flashmessage.isShowing) {
      if (this.setTimeout !== null) {
        clearTimeout(this.setTimeout);
      }
      if (this.props.flashmessage.type) {
        this.element.classList.add('notification-positive');
      } else {
        this.element.classList.add('notification-negative');
      }
      this.setTimeout = setTimeout(() => this.props.hideMessage(), 2000);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //
    if (nextProps.path !== this.props.path) {
      this.props.hideMessage();
    }
  }

  componentWillUnmount() {
    //
    this.props.hideMessage();
    clearTimeout(this.setTimeout);
  }

  render() {
    return (
      <div className={'flash-message'}>
        <a href="/#/">{this.props.flashmessage.message}</a>
      </div>
    );
  }
}

export default FlashMessage;
